<div class="page-not-found">
  <p class="lato-16-b-vw message">{{ message }}</p>
  <p class="lato-20-n-vw">You Requested the page that is no longer There.</p>
  <button class="btn btn-primary btn-lg" (click)="navigateHome()">
    Back To Home
  </button>
</div>
